import { gql } from "@apollo/client";

export const USER_EXISTS = gql`
  query UserExists($email: String!) {
    userExists(email: $email)
  }
`;
